export enum MqttBrokerType {
  Victron = 1,
  Custom = 2,
  Eniris = 3,
}
